import React from 'react';
import { useHistory } from 'react-router-dom';
import { useStyletron } from 'baseui';

import { AppBarLayout, Card } from 'commons-ui';

import AppSelect from './components/AppSelect';
import useMenuItems from './useMenuItems';

const Home: React.FC<{}> = () => {
	const [css] = useStyletron();
	const history = useHistory();
	const { menuItems } = useMenuItems();

	return (
		<>
			<AppBarLayout />
			<div
				className={css({
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'space-evenly',
					alignItems: 'center',
					height: '100%'
				})}>
				<AppSelect />
				{menuItems.map((item) => {
					return item.isEnabled() ? (
						<div
							key={item.label}
							className={css({
								height: '130px',
								width: '40%',
								cursor: 'pointer',
								display: 'flex',
								justifyContent: 'space-around'
							})}
							role='button'
							tabIndex={0}
							onClick={(e) => {
								e.preventDefault();
								history.push(item.url);
							}}>
							<Card label={item.label} img={item.img} />
						</div>
					) : null;
				})}
			</div>
		</>
	);
};

export default Home;
